import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useToast } from '@/components/ui/use-toast';
import { TLocation } from '../types';
import { label } from '@/utils/label';
import { LabelGroup } from '@/features/label/types';

const QUERY_KEY = 'TLocations';
const API_PATH = '/location';

export type UpdateTLocationDTO = {
  locationId: number;
  name: string;
  longitude: number;
  latitude: number;
  category: string;
  active: boolean;
};

export const updateLocation = (data: UpdateTLocationDTO): Promise<TLocation> => {
  return axios.put(API_PATH, data);
};

type UseUpadteLocationOptions = {
  config?: MutationConfig<typeof updateLocation>;
};

export const useUpdateLocation = ({ config }: UseUpadteLocationOptions) => {
  const { toast } = useToast();

  return useMutation({
    onMutate: async (next: any) => {
      await queryClient.cancelQueries([QUERY_KEY]);

      const prev = queryClient.getQueryData<TLocation[]>([QUERY_KEY]);

      queryClient.setQueryData([QUERY_KEY], [...(prev || []), next.data]);

      return { prev };
    },
    onError: (_, __, context: any) => {
      if (context?.prev) {
        queryClient.setQueryData([QUERY_KEY], context.prev);
      }
      toast({
        variant: 'destructive',
        title: label('something_went_wrong', LabelGroup.GLOBAL),
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_KEY]);
      queryClient.refetchQueries([QUERY_KEY]);

      toast({
        variant: 'success',
        title: label('location_updated', LabelGroup.ADMIN_LOCATION_EDIT),
      });
    },
    ...config,
    mutationFn: updateLocation,
  });
};
